import { getFirebaseAuth } from "@/lib/firebase";

export type ApiError = {
  status: number;
  body: any;
};

async function getIdToken() {
  const user = getFirebaseAuth().currentUser;
  if (!user) return null;
  return user.getIdToken();
}

export async function apiFetch<T>(path: string, init?: RequestInit & { idempotencyKey?: string }): Promise<T> {
  const headers = new Headers(init?.headers);
  const token = await getIdToken();
  if (token) headers.set("authorization", `Bearer ${token}`);
  if (init?.idempotencyKey) headers.set("idempotency-key", init.idempotencyKey);

  const resp = await fetch(path, { ...init, headers });
  const text = await resp.text();
  const body = text ? safeJson(text) : null;
  if (!resp.ok) {
    const err: ApiError = { status: resp.status, body };
    throw err;
  }
  return body as T;
}

function safeJson(text: string) {
  try {
    return JSON.parse(text);
  } catch {
    return { raw: text };
  }
}

